<!-- 协议弹窗 -->
<template>
  <div :style="custTheme">
    <div class="btns-sty">
      <el-checkbox :value="agreement" @change="beginReading">
        <span style="color: #666666">我已阅读并同意</span>
        <span @click="showProtocolPup = true">
          <a
            class="showAgreement"
            style="color: #409EFF"
            href="javascript:void(0)"
            >《数字证书服务协议》</a
          >
          <a
            class="showAgreement"
            style="color: #409EFF"
            href="javascript:void(0)"
            >《管理服务授权书》</a
          >
        </span>
      </el-checkbox>
    </div>
    <el-dialog 
      center
      width="50%"
      title="请阅读以下协议"
      :visible.sync="showProtocolPup"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dia-body-sty">
        <!-- right -->
        <div class="r-lab">
          <p :class="activeIndex === 0 ? 'active' : ''">《数字证书服务协议》</p>
          <p :class="activeIndex === 1 ? 'active' : ''">《管理服务授权书》</p>
        </div>
        <!-- left -->
        <div class="l-lab">
          <div ref="proRef" class="content-sty">
            <component :is="proViewCom"></component>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button 
          class="btn-sty"
          :disabled="btnText.indexOf('请阅读至协议末尾') > -1" 
          @click="nextProtocol"
        >{{ btnText }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import daluyundun from './pItems/daluyundun.vue';
import PrivateKeyManage from './pItems/PrivateKeyManage.vue'
import {recordTime} from '@/assets/js/utils/logStore.js'
import {getCurrentTheme} from '@/assets/js/utils/customTheme.js'

export default {
  props:{
    Agree:{
      type:Boolean,
      default:false
    }
  },
  components: {daluyundun,PrivateKeyManage},
  data () {
    // 这里存放数据
    return {
      custTheme:{}, // 页面自定义颜色。 通过var()使用css变量；组件也在使用相关变量
      agreement:false,
      showProtocolPup:false,
      btnText:'请阅读至协议末尾',
      activeIndex:0,
      count:0, // 倒计时初始值
      timer:null, // 倒计时定时器
    }
  },
  computed:{
    proViewCom(){
      switch (this.activeIndex) {
        case 0:
          return 'daluyundun';
        case 1:
          return 'PrivateKeyManage';
        default:
          break;
      }
    },
  },
  // 方法集合
  methods: {
    /** 开始阅读协议 */
    beginReading(val){
      if(val){
        this.custTheme = getCurrentTheme();
        this.showProtocolPup = true
        recordTime('readStartTime');
        recordTime('href',window.location.href);
      }
    },
    /** 关闭协议弹窗 */
    closeProtocolPup () {
      this.agreement = true;
      this.showProtocolPup = false;
      this.$emit('update:Agree', true);
      // 记录阅读结束时间
      recordTime('readEndTime');
    },
    /** 下一份协议 */
    nextProtocol() {
      // this.closeProtocolPup();
      // return;
      switch (this.activeIndex) {
        case 1:
          // 最后一份协议了，点击后可以关闭弹窗了
          // this.$emit('close',this.activeIndex);
          // 记录同意协议时间
          recordTime('checkTime');
          this.closeProtocolPup();
          break;
        default:
          this.activeIndex += 1;
          this.btnText = '请阅读至协议末尾';
          // 切换协议后，重置滚动条位置
          this.$refs.proRef.scrollTop = 0;
          // 切换协议后，重新检查是否需要禁用按钮（如果新协议内容较短，可能不需要滚动）
          this.checkScrollToBottom();
          break;
      }
    },
    /** 检查是否滚动到底部 */
    checkScrollToBottom() {
      const container = this.$refs.proRef;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      const scrollHeight = container.scrollHeight;
      // 允许 1px 的误差（某些浏览器渲染问题）
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        // 说明当前协议已经滚动到底部了。用户可以进行下一份协议的展示或者其他操作了。
        // 将当前协议key，放入sessionStorage中，表示当前协议已经阅读过了
        const protocol_read = JSON.parse(sessionStorage.getItem('protocol_read') || '[]');
        if(this.count <= 0) {
          this.btnText = '本人已阅读并同意';
          this.btnText = '下一份';
          if(this.activeIndex == 1){ this.btnText = '本人已阅读并同意'; }
        }
        if(!protocol_read.includes(this.activeIndex)){
          protocol_read.push(this.activeIndex);
          sessionStorage.setItem('protocol_read', JSON.stringify(protocol_read));
        }
      }
    },
    /** 倒计时 */
    startCountdown() {
      this.count = 3; // 倒计时
      this.btnText = `请阅读至协议末尾 (${this.count}s)`;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.count--;
        if (this.count > 0) {
          this.btnText = `请阅读至协议末尾 (${this.count}s)`;
        } else {
          this.btnText = '请阅读至协议末尾';
          // 初始检查一次，防止内容刚好满一屏（无需滚动即满足底部）
          this.checkScrollToBottom();
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
  watch: {
    // visible
    showProtocolPup:{
      handler(val){
        val && this.$nextTick(()=>{
          const container = this.$refs.proRef,read = JSON.parse(sessionStorage.getItem('protocol_read') || '[]');
          container.addEventListener('scroll', this.checkScrollToBottom);
          // 将滚动条重置到顶部，方便下一份协议的阅读
          container.scrollTop = 0;
          this.activeIndex = 0;
          this.btnText = '请阅读至协议末尾';
          // 第一次进入且没有阅读过任何协议，才会开启倒计时
          if(read && read.length == 0){
            this.startCountdown(); // 开始倒计时
          }
        })
      },
      immediate: true,
    }
  },
  destroyed() {
    const container = this.$refs.proRef;
    container && container.removeEventListener('scroll', this.checkScrollToBottom);
    clearInterval(this.timer);
  }
}
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .dia-body-sty{
    display: flex;
    .r-lab{
      width: 15%;
      > p{
        font-size: 0.8vw;
        font-weight: bolder;
        color: #333;
        margin: 10px 0;
      }
      .active{
        color: #ec1c1c;
      }
    }
    .l-lab{
      flex: 1;
      .content-sty{
        width: 100%;
        height: 500px;
        overflow-y: scroll;
        padding: 10px 0 10px 10px;
      }
    }
  }
  .cust-btn-sty{
    background-color: var(--cust-btn);
    color: var(--cust-btn-text);
    &:hover{
      opacity: 0.8;
      background-color:var(--cust-btn)
    }
  }
  /deep/ .el-dialog--center .el-dialog__footer{
    .btn-sty{
      .cust-btn-sty()
    }
  }
</style>


// WEBPACK FOOTER //
// components/protocol/indexNew.vue